@if (visible) {
  <div
    class="user-change-password-modal"
    (keyup.escape)="onCancel()"
    tabindex="0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="change-password-modal-title"
  >
    <div class="user-change-password-modal__content">
      <div class="user-change-password-modal__header">
        <h3 id="change-password-modal-title">Change Password</h3>
        <button
          type="button"
          class="user-change-password-modal__close"
          (click)="onCancel()"
          (keyup.enter)="onCancel()"
          [attr.aria-label]="'Close'"
        >
          <kendo-svg-icon [icon]="xIconSvg"></kendo-svg-icon>
        </button>
      </div>

      <div class="user-change-password-modal__body">
        <app-password-field
          [minStrength]="3"
          (isValidChange)="onPasswordValidityChange($event)"
        ></app-password-field>

        @if (errorMessage) {
          <div class="user-change-password-modal__form-error-message">
            {{ errorMessage }}
          </div>
        }
      </div>

      <div class="user-change-password-modal__modal-actions">
        <app-secondary-button type="button" (click)="onCancel()">Close</app-secondary-button>
        <app-primary-button type="button" [disabled]="!isPasswordValid" (click)="onSave($event)">
          Save
        </app-primary-button>
      </div>
    </div>
  </div>
}
